import { useEffect } from 'react';

export default function HomePage() {
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector('.navbar-scroll');
      if (navbar) {
        if (window.scrollY > 100) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#E8E4DC] font-mono">
      {/* Background Pattern */}
      <div className="fixed inset-0 opacity-[0.03] pointer-events-none"></div>

      {/* Animated Blobs Background */}
      <div className="fixed inset-0 opacity-[0.08] pointer-events-none">
        <div className="absolute top-[-10%] left-[-5%] w-[600px] h-[600px] rounded-[40%_60%_70%_30%/60%_30%_70%_40%] bg-gradient-radial from-[#4A4A4A] via-[#6A6A6A] to-[#8A8A8A] blur-[100px] animate-blob-morph"></div>
        <div className="absolute top-[10%] right-[-10%] w-[550px] h-[550px] rounded-[60%_40%_30%_70%/40%_60%_70%_30%] bg-gradient-radial from-[#5A5A5A] via-[#7A7A7A] to-[#4A4A4A] blur-[100px] animate-blob-morph-2"></div>
        <div className="absolute bottom-[-15%] left-[20%] w-[650px] h-[650px] rounded-[30%_70%_70%_30%/30%_30%_70%_70%] bg-gradient-radial from-[#6A6A6A] via-[#4A4A4A] to-[#5A5A5A] blur-[100px] animate-blob-morph-3"></div>
        <div className="absolute bottom-[5%] right-[15%] w-[500px] h-[500px] rounded-[70%_30%_50%_50%/60%_40%_60%_40%] bg-gradient-radial from-[#7A7A7A] via-[#5A5A5A] to-[#4A4A4A] blur-[100px] animate-blob-morph-4"></div>
        <div className="absolute top-[40%] left-[40%] w-[450px] h-[450px] rounded-[50%_50%_30%_70%/50%_50%_70%_30%] bg-gradient-radial from-[#5A5A5A] via-[#6A6A6A] to-[#7A7A7A] blur-[100px] animate-blob-morph-5"></div>
      </div>

      <div className="relative">
        {/* Hero Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 relative overflow-hidden">
          <div className="max-w-[720px] mx-auto relative z-10">
            {/* Title */}
            <div className="text-center mb-8">
              <h1 className="text-[80px] md:text-[120px] font-black leading-none tracking-tight text-[#4A4A4A] mb-6">
                WANTED
              </h1>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 mb-8">
                <div className="h-[1px]"></div>
              </div>
            </div>

            {/* Profile Image with Badge */}
            <div className="flex flex-col items-center mb-8 relative">
              {/* Available Badge */}
              <div className="absolute top-0 right-4 md:right-12 z-10 transform rotate-12">
                <div className="relative">
                  <div className="border-4 border-red-600 rounded-lg px-6 py-3 opacity-70">
                    <span className="text-sm md:text-base font-black text-red-600 tracking-wider uppercase">
                      Available for Work
                    </span>
                  </div>
                </div>
              </div>

              {/* Profile Image */}
              <div className="w-[330px] h-auto mb-6 mt-8">
                <img
                  src="https://framerusercontent.com/images/XteGpXOCn4knl5fdSx7wXiDg.png"
                  alt="Karim Elhawary - Corporate Lawyer"
                  title="Karim Elhawary - Corporate Lawyer"
                  className="w-full h-auto"
                />
              </div>

              {/* Name Plate */}
              <div className="bg-[#4A4A4A] text-white px-8 py-3 text-center">
                <h2 className="text-xl font-bold tracking-wide">Karim Elhawary</h2>
                <p className="text-sm mt-1 opacity-90">Corporate Lawyer | Business Development Manager</p>
                <p className="text-xs mt-1 opacity-80">AI & Automation Strategist</p>
              </div>
            </div>

            {/* Divider */}
            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 my-8">
              <div className="h-[1px]"></div>
            </div>

            {/* Founder Section */}
            <div className="text-center mb-8">
              <h3 className="text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-4">Founder | Partner manager</h3>
              <p className="text-sm md:text-base text-[#4A4A4A] leading-relaxed mb-6 max-w-[600px] mx-auto">
                Aaron AI for automation solutions, King TUT Recruit for employment relationships & Elhawary Brothers LLC for legal services
              </p>
            </div>

            {/* Divider */}
            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 my-8">
              <div className="h-[1px]"></div>
            </div>

            {/* Have an Idea Section */}
            <div className="text-center">
              <h3 className="text-2xl md:text-3xl font-bold text-[#4A4A4A] mb-6">Have an Idea or need Help!</h3>
              
              {/* Social Icons Grid */}
              <div className="flex flex-wrap justify-center gap-3 mb-6 max-w-[600px] mx-auto">
                <a href="https://twitter.com/karimElhawry89" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Twitter">
                  <i className="ri-twitter-x-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.tiktok.com/@karimelhawary_3" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="TikTok">
                  <i className="ri-tiktok-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.instagram.com/elhawarykarim/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Instagram">
                  <i className="ri-instagram-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://github.com/karimelhawary89" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="GitHub">
                  <i className="ri-github-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.linkedin.com/in/karim-elhawary-393358100" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="LinkedIn">
                  <i className="ri-linkedin-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.facebook.com/karim.elhawary.9/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Facebook">
                  <i className="ri-facebook-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="tel:+201000867697" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Mobile">
                  <i className="ri-phone-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="mailto:Karimelhawary89@gmail.com" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Email">
                  <i className="ri-mail-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://wa.me/201000867697" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="WhatsApp">
                  <i className="ri-whatsapp-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.fiverr.com/karim_elhawary?public_mode=true" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Fiverr">
                  <i className="ri-service-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.upwork.com/freelancers/~01fd92d108da6a2a8a" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Upwork">
                  <i className="ri-briefcase-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.reddit.com/user/Critical-Gap4186/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Reddit">
                  <i className="ri-reddit-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://karimelhawary.substack.com/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Substack">
                  <i className="ri-newspaper-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://medium.com/@karimelhawary89" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Medium">
                  <i className="ri-medium-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://discord.com/invite/b4a4V9xB" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Discord">
                  <i className="ri-discord-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://web.telegram.org/k/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Telegram">
                  <i className="ri-telegram-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://paypal.me/hawary007?country.x=EG&locale.x=en_US" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="PayPal">
                  <i className="ri-paypal-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://producthunt.com/@karim_el_hawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Product Hunt">
                  <i className="ri-product-hunt-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.youtube.com/@ElhawaryBrothers" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="YouTube">
                  <i className="ri-youtube-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://buymeacoffee.com/hawary" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Buy Me A Coffee">
                  <i className="ri-cup-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://elhawary-brothers.slack.com/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Slack">
                  <i className="ri-slack-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.etsy.com/people/l2mrt6uz9zxq4v0v" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Etsy">
                  <i className="ri-shopping-bag-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.tumblr.com/blog/elhawarybrothers" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Tumblr">
                  <i className="ri-tumblr-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://karimelhawary.gumroad.com/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Gumroad">
                  <i className="ri-store-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://karimelhawary.blogspot.com/" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Blogger">
                  <i className="ri-blogger-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://pinterest.com" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Pinterest">
                  <i className="ri-pinterest-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://vimeo.com/user220472934" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Vimeo">
                  <i className="ri-vimeo-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://open.spotify.com/user/31l6gmubps63blzp7cyxc2cvyefy" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Spotify">
                  <i className="ri-spotify-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://dribbble.com/Hawary_AI" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Dribbble">
                  <i className="ri-dribbble-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.behance.net/karimelhawary3" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Behance">
                  <i className="ri-behance-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://notion.so" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Notion">
                  <i className="ri-notion-fill text-xl text-[#4A4A4A]"></i>
                </a>
                <a href="https://www.skool.com/@karim-elhawary-2462?g=ai-automation-mastery" target="_blank" rel="noopener noreferrer" className="w-12 h-12 flex items-center justify-center bg-white/60 border-2 border-dashed border-[#4A4A4A] hover:bg-white/80 transition-colors cursor-pointer" title="Skool">
                  <i className="ri-graduation-cap-fill text-xl text-[#4A4A4A]"></i>
                </a>
              </div>

              <p className="text-sm text-[#4A4A4A] leading-relaxed max-w-[600px] mx-auto">
                Never hesitate to Contact me, 24/7 we promise you professionally containment and covering troubles even before being in a trouble.
              </p>
            </div>

            {/* Divider */}
            <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2">
              <div className="h-[1px]"></div>
            </div>

            {/* CTA Button */}
            <div className="text-center mt-8">
              <a
                href="#intro"
                className="inline-block bg-[#4A4A4A] text-white px-6 py-3 text-sm font-bold tracking-wide uppercase cursor-pointer hover:opacity-80 transition-opacity whitespace-nowrap"
              >
                Explore More ↓
              </a>
            </div>
          </div>
        </section>

        {/* Introduction Section - From Gamma */}
        <section id="intro" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-20 bg-gradient-to-br from-stone-100/50 to-amber-50/30">
          <div className="max-w-[1400px] mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              {/* Left - Image */}
              <div className="order-2 lg:order-1">
                <div className="border-4 border-dashed border-[#4A4A4A] overflow-hidden bg-white/60 p-8">
                  <div className="w-full h-[400px] bg-gradient-to-br from-amber-100 to-stone-100 flex items-center justify-center">
                    <i className="ri-scales-3-line text-[120px] text-[#4A4A4A] opacity-20"></i>
                  </div>
                </div>
              </div>

              {/* Right - Content */}
              <div className="order-1 lg:order-2">
                <div className="bg-white/40 border-2 border-dashed border-[#4A4A4A] p-8">
                  <h2 className="text-[42px] md:text-[56px] font-black leading-tight text-[#4A4A4A] mb-6">
                    ELHAWARY BROTHERS LLC
                  </h2>
                  <div className="border-t-2 border-dashed border-[#4A4A4A] my-6"></div>
                  <p className="text-lg text-[#4A4A4A] leading-relaxed mb-6">
                    We're an <strong>Alexandria, Egypt-based law firm</strong> that's always available to answer your questions, review contracts, and help you with anything on your mind.
                  </p>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">
                    A leading Egyptian law firm empowering foreign companies to navigate the legal complexities of doing business in Egypt. We provide comprehensive legal services tailored to international businesses seeking to establish and grow their presence in the Egyptian market.
                  </p>
                  <div className="flex flex-wrap gap-4 mt-8">
                    <a 
                      href="#services"
                      className="inline-block bg-amber-600 text-white px-6 py-3 text-sm font-bold border-2 border-dashed border-[#4A4A4A] hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
                    >
                      OUR SERVICES
                    </a>
                    <a 
                      href="mailto:elhawarybrothersllc@gmail.com"
                      className="inline-block bg-[#4A4A4A] text-white px-6 py-3 text-sm font-bold hover:opacity-80 transition-opacity whitespace-nowrap cursor-pointer"
                    >
                      CONTACT US
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Mission & Vision Section - From Gamma */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                OUR MISSION & VISION
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                The principles that guide everything we do
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Mission */}
              <div className="bg-gradient-to-br from-amber-100/60 to-amber-50/40 border-4 border-dashed border-amber-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-600 border-2 border-dashed border-[#4A4A4A] mb-6 mx-auto">
                  <i className="ri-target-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4 text-center">OUR MISSION</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed text-center">
                  To provide exceptional legal services that empower businesses to thrive in Egypt's dynamic market. We are committed to delivering practical, innovative solutions while maintaining the highest standards of professionalism and integrity.
                </p>
              </div>

              {/* Vision */}
              <div className="bg-gradient-to-br from-teal-100/60 to-teal-50/40 border-4 border-dashed border-teal-600 p-8">
                <div className="w-16 h-16 flex items-center justify-center bg-teal-600 border-2 border-dashed border-[#4A4A4A] mb-6 mx-auto">
                  <i className="ri-eye-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-black text-[#4A4A4A] mb-4 text-center">OUR VISION</h3>
                <p className="text-base text-[#4A4A4A] leading-relaxed text-center">
                  To be the leading legal partner for international businesses entering the Egyptian market, recognized for our expertise, reliability, and commitment to client success. We envision a future where legal barriers never stand in the way of business growth.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Core Values Section - From Gamma */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                CORE VALUES
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">
                The principles that guide everything we do
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* Integrity */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">INTEGRITY</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We uphold the highest ethical standards in all our dealings, ensuring transparency and honesty with every client.
                </p>
              </div>

              {/* Excellence */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-star-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">EXCELLENCE</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We strive for excellence in every aspect of our work, continuously improving our services and expertise.
                </p>
              </div>

              {/* Client Focus */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-user-heart-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">CLIENT FOCUS</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  Your success is our priority. We tailor our services to meet your unique needs and business objectives.
                </p>
              </div>

              {/* Innovation */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-lightbulb-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">INNOVATION</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We embrace modern technology and innovative approaches to deliver efficient, effective legal solutions.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* The Ecosystem Section */}
        <section id="ecosystem" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            {/* Section Title */}
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                THE ECOSYSTEM
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto">
                <div className="h-[1px]"></div>
              </div>
            </div>

            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Card 1 - Aaron AI Services */}
              <div className="bg-white/40 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="text-xs font-bold text-[#4A4A4A] mb-4 tracking-wider">AARON AI SERVICES</div>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <div className="text-sm leading-relaxed text-[#4A4A4A] max-h-[400px] overflow-y-auto pr-2">
                    <h3 className="font-bold mb-3 text-base">Comprehensive Marketing Solutions</h3>
                    <p className="mb-4">
                      We offer comprehensive marketing solutions for B2B businesses and call centers, helping clients understand the value of our services through a detailed breakdown of each step.
                    </p>
                    <h4 className="font-bold mt-4 mb-2">Market Research &amp; Competitor Analysis</h4>
                    <p className="mb-3">
                      We conduct in-depth market research to understand the industry landscape, target audience, and key competitors. This includes analyzing competitor strategies, identifying market gaps, and understanding customer pain points.
                    </p>
                  </div>
                </div>
              </div>

              {/* Card 2 - Profile */}
              <div className="bg-white/40 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="text-xs font-bold text-[#4A4A4A] mb-4 tracking-wider">PROFESSIONAL PROFILE</div>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <div className="text-sm leading-relaxed text-[#4A4A4A] max-h-[400px] overflow-y-auto pr-2">
                    <h3 className="font-bold text-base mb-3">Karim El Hawary</h3>
                    <p className="mb-4">
                      Corporate lawyer and legal services provider. Management partner at Elhawary Brothers LLC and CEO at King TUT Recruit company.
                    </p>
                    <div className="space-y-3">
                      <div>
                        <p className="font-semibold mb-1">Twitter</p>
                        <p className="text-xs">@karimElhawry89</p>
                      </div>
                      <div>
                        <p className="font-semibold mb-1">LinkedIn</p>
                        <p className="text-xs">linkedin.com/in/karimelhawary</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 3 - Aaron AI Home */}
              <div className="bg-white/40 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="text-xs font-bold text-[#4A4A4A] mb-4 tracking-wider">AARON AI</div>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <div className="text-sm leading-relaxed text-[#4A4A4A] max-h-[400px] overflow-y-auto pr-2">
                    <h3 className="font-bold text-base mb-3">Leading Legal Consulting Solutions Provider</h3>
                    <h4 className="font-bold mb-2 mt-4">Latest Insights</h4>
                    <div className="mb-4">
                      <p className="font-semibold mb-2">Boosting Conversions with AI Lead Generation</p>
                      <p className="mb-2">
                        In the competitive landscape of digital marketing for law firms and legal professionals, staying ahead of the curve is essential. With the advancement of AI technology, lead generation has witnessed a transformative shift, enabling agencies to boost conversions and engage clients effectively.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Legal OS Section */}
        <section id="legal-os" className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            {/* Section Title */}
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                LEGAL OS
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto">
                <div className="h-[1px]"></div>
              </div>
            </div>

            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Legal Services Card */}
              <div className="bg-white/40 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="text-xs font-bold text-[#4A4A4A] mb-4 tracking-wider">ELHAWARY BROTHERS LLC</div>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <div className="text-sm leading-relaxed text-[#4A4A4A] max-h-[400px] overflow-y-auto pr-2">
                    <h3 className="font-bold text-base mb-3">
                      Expert Legal Advice for Your Business
                    </h3>
                    <p className="mb-4">
                      We're an Alexandria, Egypt-based law firm that's always available to answer your questions, review contracts, and help you with anything on your mind.
                    </p>
                    <h4 className="font-bold mb-2 mt-4">Employment &amp; Labor Law</h4>
                    <p className="font-semibold mb-2 text-xs">Empowering Your Workforce, Protecting Your Business</p>
                    <p className="mb-3">
                      Stay compliant and create a thriving work environment with our employment and labor law services. From drafting employment contracts to resolving disputes, we provide the legal support you need to nurture your talent and protect your interests.
                    </p>
                  </div>
                </div>
              </div>

              {/* Legal Expertise Card */}
              <div className="bg-white/40 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="text-xs font-bold text-[#4A4A4A] mb-4 tracking-wider">LEGAL EXPERTISE</div>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <div className="text-sm leading-relaxed text-[#4A4A4A] max-h-[400px] overflow-y-auto pr-2">
                    <h3 className="font-bold text-base mb-3">Comprehensive Legal Solutions</h3>
                    <p className="mb-4">
                      Get the legal knowledge and advice your business deserves. We provide comprehensive legal consultation services tailored to your specific needs.
                    </p>
                    <div className="space-y-3">
                      <div>
                        <p className="font-semibold mb-1">Contract Review</p>
                        <p className="text-xs">Thorough analysis and review of all business contracts</p>
                      </div>
                      <div>
                        <p className="font-semibold mb-1">Legal Consultation</p>
                        <p className="text-xs">Expert advice on corporate and business matters</p>
                      </div>
                      <div>
                        <p className="font-semibold mb-1">Compliance Support</p>
                        <p className="text-xs">Ensuring your business meets all legal requirements</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* US Government Procurement Section - NEW FROM GAMMA */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-red-50/40 to-blue-50/40">
          <div className="max-w-[1400px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                US GOVERNMENT PROCUREMENT
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                Expert guidance for businesses seeking to work with the US Government
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
              {/* Left - Image */}
              <div className="order-2 lg:order-1">
                <div className="border-4 border-dashed border-[#4A4A4A] overflow-hidden bg-white/60">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/050ae41bb0af2214c2dfa2d334143ba8.jpg"
                    alt="US Government Procurement"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>

              {/* Right - Content */}
              <div className="order-1 lg:order-2">
                <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 h-full">
                  <h3 className="text-3xl font-black text-[#4A4A4A] mb-6">Navigate Federal Contracting with Confidence</h3>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-4">
                    The US Government is the world's largest buyer of goods and services, spending over <strong>$600 billion annually</strong> on contracts. We help businesses understand and access these opportunities.
                  </p>
                  <p className="text-base text-[#4A4A4A] leading-relaxed mb-6">
                    Our team provides comprehensive support for companies seeking to do business with federal agencies, from registration to contract execution and compliance.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                      <div>
                        <p className="font-bold text-[#4A4A4A]">SAM Registration Assistance</p>
                        <p className="text-sm text-[#4A4A4A]">Complete support for System for Award Management registration</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                      <div>
                        <p className="font-bold text-[#4A4A4A]">Compliance & Regulations</p>
                        <p className="text-sm text-[#4A4A4A]">Navigate FAR, DFARS, and other federal regulations</p>
                      </div>
                    </div>
                    <div className="flex items-start space-x-3">
                      <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                      <div>
                        <p className="font-bold text-[#4A4A4A]">Proposal Development</p>
                        <p className="text-sm text-[#4A4A4A]">Expert assistance in preparing winning proposals</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-government-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Federal Registration</h4>
                <p className="text-sm text-[#4A4A4A]">SAM.gov, CAGE codes, and DUNS number assistance</p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-file-list-3-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Contract Compliance</h4>
                <p className="text-sm text-[#4A4A4A]">Ensure adherence to federal acquisition regulations</p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-search-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Opportunity Identification</h4>
                <p className="text-sm text-[#4A4A4A]">Find and track relevant government contracts</p>
              </div>

              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 text-center hover:bg-white/80 transition-colors">
                <div className="w-16 h-16 flex items-center justify-center bg-red-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-red-700"></i>
                </div>
                <h4 className="text-lg font-bold text-[#4A4A4A] mb-2">Certification Support</h4>
                <p className="text-sm text-[#4A4A4A]">Small business, veteran, and minority certifications</p>
              </div>
            </div>

            {/* Key Benefits */}
            <div className="mt-12 bg-gradient-to-r from-red-600/90 to-blue-600/90 border-4 border-dashed border-[#4A4A4A] p-8">
              <h3 className="text-3xl font-black text-white text-center mb-8">Why Work with US Government?</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="text-center text-white">
                  <div className="text-4xl font-black mb-2">$600B+</div>
                  <p className="text-sm opacity-90">Annual Contract Spending</p>
                </div>
                <div className="text-center text-white">
                  <div className="text-4xl font-black mb-2">23%</div>
                  <p className="text-sm opacity-90">Reserved for Small Businesses</p>
                </div>
                <div className="text-center text-white">
                  <div className="text-4xl font-black mb-2">100+</div>
                  <p className="text-sm opacity-90">Federal Agencies</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Legal Services Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                OUR SERVICES
              </h2>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">
                Get the legal knowledge and advice your business deserves
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {/* Legal Consultation */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-scales-3-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Legal Consultation</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Navigate the complexities of corporate law with our tailored legal consultation services. We provide comprehensive guidance on corporate structures, contract negotiations, and international trade compliance.
                </p>
              </div>

              {/* Company Incorporation */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-building-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Company Incorporation & Registration</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Make your mark in Egypt effortlessly with our company incorporation and registration services. We handle everything from legal formalities to securing the necessary licenses.
                </p>
              </div>

              {/* Real Estate */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-home-4-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Real Estate & Property Law</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Whether you're buying, leasing, or developing property in Egypt, our real estate legal experts are here to guide you through every step.
                </p>
              </div>

              {/* Employment Law */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-team-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Employment & Labor Law</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Stay compliant and create a thriving work environment with our employment and labor law services. From drafting employment contracts to resolving disputes.
                </p>
              </div>

              {/* Mergers & Acquisitions */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-exchange-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Mergers & Acquisitions</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Navigate the intricate world of M&A with confidence. Our legal team provides thorough due diligence and strategic advice on transaction structuring.
                </p>
              </div>

              {/* Cross-Border Services */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6 hover:bg-white/80 transition-colors">
                <div className="w-14 h-14 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mb-4">
                  <i className="ri-global-line text-2xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Cross-Border Legal Services</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4">
                  Expand your business horizons with our cross-border legal services. From legal opinions to translation, we provide the support you need to navigate international law.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Industry Expertise Section - From Gamma */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                INDUSTRY EXPERTISE
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[900px] mx-auto">
                Deep sector knowledge across multiple industries
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
              {[
                { icon: 'ri-building-2-line', name: 'Technology' },
                { icon: 'ri-shopping-cart-line', name: 'E-Commerce' },
                { icon: 'ri-hospital-line', name: 'Healthcare' },
                { icon: 'ri-bank-line', name: 'Finance' },
                { icon: 'ri-oil-line', name: 'Energy' },
                { icon: 'ri-building-4-line', name: 'Real Estate' },
                { icon: 'ri-restaurant-line', name: 'Hospitality' },
                { icon: 'ri-truck-line', name: 'Logistics' },
                { icon: 'ri-store-2-line', name: 'Retail' },
                { icon: 'ri-plant-line', name: 'Agriculture' }
              ].map((industry, index) => (
                <div key={index} className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-4 text-center hover:bg-white/80 transition-colors">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-3">
                    <i className={`${industry.icon} text-xl text-amber-700`}></i>
                  </div>
                  <p className="text-sm font-bold text-[#4A4A4A]">{industry.name}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why Choose Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                WHY CHOOSE US
              </h2>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">
                We combine deep local expertise with international perspective to deliver exceptional legal services
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-user-star-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Expert Legal Team</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  Our experienced attorneys specialize in Egyptian law and international business transactions.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-global-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">International Focus</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We understand the unique challenges foreign companies face when doing business in Egypt.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-customer-service-2-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Always Available</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  We're committed to being accessible whenever you need legal guidance or support.
                </p>
              </div>

              <div className="text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-shield-check-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">Comprehensive Services</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  From incorporation to dispute resolution, we handle all your legal needs under one roof.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* AI Assistant Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-50/30 to-stone-50/30">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-8">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                CHAT WITH OUR AI
              </h2>
              <p className="text-lg text-[#4A4A4A] max-w-[700px] mx-auto mb-8">
                Get instant answers to your legal questions 24/7 with our intelligent AI assistants
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Arabic AI Assistant */}
              <div className="bg-white/60 border-4 border-dashed border-teal-600 rounded-lg overflow-hidden shadow-2xl">
                <div className="bg-teal-600 text-white px-6 py-3 text-center">
                  <h3 className="text-xl font-bold">🇪🇬 Arabic Assistant | المساعد العربي</h3>
                  <p className="text-sm mt-1 opacity-90">For Arabic-speaking users</p>
                </div>
                <iframe 
                  src="https://www.chatbase.co/iulM72SuEso5EHol-qdQC/help" 
                  title="Arabic AI Chat Assistant"
                  className="w-full h-[600px]"
                ></iframe>
              </div>

              {/* English AI Assistant */}
              <div className="bg-white/60 border-4 border-dashed border-amber-600 rounded-lg overflow-hidden shadow-2xl">
                <div className="bg-amber-600 text-white px-6 py-3 text-center">
                  <h3 className="text-xl font-bold">🇬🇧 English Assistant</h3>
                  <p className="text-sm mt-1 opacity-90">For English-speaking users</p>
                </div>
                <iframe 
                  src="https://app.simli.com/session/abc17eef-da42-4794-b552-c980c638cb99/gAAAAABpM5wHgcgWS312ZYbcVCLUr2foFG0RFq3a_6L9dlFos_DiC1VMVXhdVhDhRSWk0sh3D-Ti2VSxMGCvmQhBuNEf1NUEfI6fbQLB3iYah2XCNZaaBMk46EKnGfcRiHV7kuA-2dUETKoWbdt1hE50N0LT-JE187cpRLpC7DT449Lp0fWQKVa-Lk8uVmx0mFh75ZYEqit9fQauYEE__76nlhFvRq7EsBg2iJl3CBA34dsAZL9yPDfy9L9HZ9JdSVJ_3sFo4-QWBOYId5baxJ3altO8BNabsuIYsT1k4Lp4xN6CaYJKpW2DlOYO990PysmErnbQ4YZ1gw1c4rUF9njoU9YMZYB7hXGeoWUNLa8BQk4up04i2MpQ00-vVmSc-eMUVc3-oO9eeobL6ktK8hQJp_wtFCBkF-BNUcCtgBUObEeh2uy_4R9b5XKKfkINH4JugZNnqrYz" 
                  title="English AI Voice Assistant"
                  className="w-full h-[600px]"
                  allow="microphone"
                ></iframe>
              </div>
            </div>

            <div className="text-center mt-8">
              <p className="text-sm text-[#4A4A4A]">
                Our AI assistants can help you with contract reviews, legal questions, and service inquiries in both Arabic and English
              </p>
            </div>
          </div>
        </section>

        {/* Testimonials Section - From Gamma */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                CLIENT TESTIMONIALS
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">
                What our clients say about working with us
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Testimonial 1 */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4 italic">
                  "Elhawary Brothers made our company registration in Egypt seamless. Their expertise and professionalism exceeded our expectations. Highly recommended!"
                </p>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <p className="font-bold text-[#4A4A4A]">Sarah Johnson</p>
                  <p className="text-xs text-[#4A4A4A] opacity-70">CEO, TechStart International</p>
                </div>
              </div>

              {/* Testimonial 2 */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4 italic">
                  "Outstanding legal support for our M&A transaction. The team's attention to detail and deep market knowledge were invaluable."
                </p>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <p className="font-bold text-[#4A4A4A]">Michael Chen</p>
                  <p className="text-xs text-[#4A4A4A] opacity-70">CFO, Global Ventures Ltd</p>
                </div>
              </div>

              {/* Testimonial 3 */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                <div className="flex items-center mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-amber-500 text-lg"></i>
                  ))}
                </div>
                <p className="text-sm text-[#4A4A4A] leading-relaxed mb-4 italic">
                  "Professional, responsive, and always available. They guided us through complex employment law matters with ease."
                </p>
                <div className="border-t border-dashed border-[#4A4A4A] pt-4">
                  <p className="font-bold text-[#4A4A4A]">Emma Williams</p>
                  <p className="text-xs text-[#4A4A4A] opacity-70">HR Director, Retail Solutions</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section - From Gamma */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-white/20">
          <div className="max-w-[900px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                FREQUENTLY ASKED QUESTIONS
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto">
                <div className="h-[1px]"></div>
              </div>
            </div>

            <div className="space-y-4">
              {[
                {
                  q: "How long does it take to register a company in Egypt?",
                  a: "The company registration process typically takes 2-4 weeks, depending on the type of entity and completeness of documentation. We streamline this process to ensure the fastest possible turnaround."
                },
                {
                  q: "Do you provide services in English?",
                  a: "Yes, we provide full legal services in both English and Arabic. Our team is fluent in both languages and experienced in working with international clients."
                },
                {
                  q: "What are your consultation fees?",
                  a: "We offer a free initial consultation to understand your needs. Our fee structure is transparent and competitive, with options for hourly rates or fixed-fee arrangements depending on the service."
                },
                {
                  q: "Can you help with visa and work permit applications?",
                  a: "Yes, we assist with all aspects of immigration law, including visa applications, work permits, and residency requirements for foreign nationals and their families."
                },
                {
                  q: "Do you handle dispute resolution and litigation?",
                  a: "Yes, we provide comprehensive dispute resolution services, including negotiation, mediation, arbitration, and litigation representation in Egyptian courts."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-6">
                  <h3 className="text-lg font-bold text-[#4A4A4A] mb-3 flex items-start">
                    <span className="text-amber-600 mr-3">Q:</span>
                    {faq.q}
                  </h3>
                  <p className="text-sm text-[#4A4A4A] leading-relaxed pl-8">
                    <span className="text-teal-600 font-bold mr-2">A:</span>
                    {faq.a}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Information Section - From Gamma */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-amber-50/30 to-stone-50/30">
          <div className="max-w-[1200px] mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-[#4A4A4A] mb-4">
                GET IN TOUCH
              </h2>
              <div className="border-t-2 border-b-2 border-dashed border-[#4A4A4A] py-2 max-w-[600px] mx-auto mb-6">
                <div className="h-[1px]"></div>
              </div>
              <p className="text-lg text-[#4A4A4A] max-w-[800px] mx-auto">
                We're here to help. Reach out to us through any of these channels
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* Office Location */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">OFFICE LOCATION</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  Alexandria, Egypt<br />
                  Available for in-person consultations
                </p>
              </div>

              {/* Contact Details */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-phone-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">CONTACT DETAILS</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  <a href="tel:+201000867697" className="hover:text-amber-600 transition-colors cursor-pointer">+20 100 086 7697</a><br />
                  <a href="mailto:elhawarybrothersllc@gmail.com" className="hover:text-amber-600 transition-colors cursor-pointer">elhawarybrothersllc@gmail.com</a>
                </p>
              </div>

              {/* Business Hours */}
              <div className="bg-white/60 border-2 border-dashed border-[#4A4A4A] p-8 text-center">
                <div className="w-16 h-16 flex items-center justify-center bg-amber-100 border-2 border-dashed border-[#4A4A4A] mx-auto mb-4">
                  <i className="ri-time-line text-3xl text-amber-700"></i>
                </div>
                <h3 className="text-xl font-bold text-[#4A4A4A] mb-3">AVAILABILITY</h3>
                <p className="text-sm text-[#4A4A4A] leading-relaxed">
                  24/7 Support Available<br />
                  We're always here when you need us
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="border-b-2 border-dashed border-[#4A4A4A] px-6 py-16 bg-gradient-to-br from-teal-600/90 to-teal-700/90">
          <div className="max-w-[900px] mx-auto text-center">
            <h2 className="text-[48px] md:text-[64px] font-black leading-none tracking-tight text-white mb-6">
              READY TO GET STARTED?
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-[700px] mx-auto">
              Contact us today to discuss your legal needs and discover how we can help your business succeed in Egypt
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="mailto:elhawarybrothersllc@gmail.com"
                className="inline-block bg-amber-600 text-white px-8 py-4 text-lg font-bold border-2 border-dashed border-white hover:bg-amber-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                CONTACT US TODAY
              </a>
              <a 
                href="#services"
                className="inline-block bg-transparent border-2 border-dashed border-white text-white px-8 py-4 text-lg font-bold hover:bg-white hover:text-[#4A4A4A] transition-colors whitespace-nowrap cursor-pointer"
              >
                VIEW OUR SERVICES
              </a>
            </div>
          </div>
        </section>

        {/* Footer */}
        <footer className="px-6 py-12 bg-stone-800 text-stone-200">
          <div className="max-w-[1200px] mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
              <div className="col-span-1 md:col-span-2">
                <div className="flex items-center space-x-3 mb-4">
                  <img 
                    src="https://aaronai.my.canva.site/we-re-elhawary-brothers-for-legal-service-always-available-to-answer-your-questions-review-contracts-and-help-you-with-anything-on-your-mind/images/6d56202f5cc6c783dbd3ce2db48c755d.png" 
                    alt="Elhawary Brothers LLC" 
                    className="h-12 w-12"
                  />
                  <span className="text-xl font-bold">Elhawary Brothers LLC</span>
                </div>
                <p className="text-stone-400 mb-4 max-w-md text-sm">
                  A leading Egyptian law firm empowering foreign companies to navigate the legal complexities of doing business in Egypt.
                </p>
                <div className="flex space-x-4">
                  <a href="https://www.facebook.com/profile.php?id=61557350524776" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-facebook-fill text-lg"></i>
                  </a>
                  <a href="https://www.linkedin.com/company/elhawary-brothers-llc/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-linkedin-fill text-lg"></i>
                  </a>
                  <a href="https://www.instagram.com/elhawarybrothers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-instagram-line text-lg"></i>
                  </a>
                  <a href="https://www.youtube.com/@ElhawaryBrothers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-youtube-fill text-lg"></i>
                  </a>
                  <a href="https://wa.me/+201000867697" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-stone-700 hover:bg-amber-700 border border-dashed border-stone-500 transition-colors cursor-pointer">
                    <i className="ri-whatsapp-line text-lg"></i>
                  </a>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-bold mb-4 text-white">Quick Links</h3>
                <ul className="space-y-2 text-sm">
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="#services">Services</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="#ecosystem">Ecosystem</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="#legal-os">Legal OS</a></li>
                  <li><a className="text-stone-400 hover:text-amber-500 transition-colors cursor-pointer" href="/">Home</a></li>
                </ul>
              </div>

              <div>
                <h3 className="text-lg font-bold mb-4 text-white">Contact Info</h3>
                <ul className="space-y-3 text-stone-400 text-sm">
                  <li className="flex items-start space-x-2">
                    <i className="ri-map-pin-line text-amber-500 mt-1"></i>
                    <span>Alexandria, Egypt</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-phone-line text-amber-500 mt-1"></i>
                    <span>+201000867697</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-mail-line text-amber-500 mt-1"></i>
                    <span>elhawarybrothersllc@gmail.com</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="border-t border-dashed border-stone-700 pt-8 flex flex-col md:flex-row justify-between items-center">
              <p className="text-stone-400 text-xs mb-4 md:mb-0">© 2025 Elhawary Brothers LLC. All rights reserved.</p>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-stone-400 hover:text-amber-500 text-xs transition-colors cursor-pointer"
              >
                Website Builder
              </a>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
}
